import { useState } from 'react';
export const useOnExpand = (
/** Value from Option. Accepts an array of any content */
value) => {
    const getValue = Array.isArray(value) ? value : [value];
    const [expandValue, setExpandValue] = useState([...getValue]);
    const setCollapseValue = (data) => {
        expandValue.includes(data)
            ? setExpandValue((prevState) => [...prevState].filter((item) => item !== data))
            : setExpandValue((prevState) => [...prevState, data]);
        return expandValue;
    };
    return [expandValue, setCollapseValue];
};
//# sourceMappingURL=useOnExpand.js.map